import type { Prototype } from "../prototype-types";

export const rebeccaGrayPrototypes: Prototype[] = [
  {
    id: "retailer-command-center",
    name: "Retailer Command Center",
    path: "/rg/retailer-command-center",
    description:
      "A surface that combines things retailers want to access easily: orders in progress, reorder (running low, quick add by SKU, upload PO), deals/expiring promos, and new from your brands.",
    owner: "Reba",
    createdAt: "2026-03-03",
    lastUpdated: "2026-03-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/57be4ab31e718a52c3c0a058ec07df0b902d7554a84229573efeebaede4c6bd0.png",
    creationTool: "cursor",
  },
];
